import type { NotificationListResponseNotificationsItemSourceSourceUser } from './notificationListResponseNotificationsItemSourceSourceUser';

/**
 * 알림 소스 정보
 */
export type NotificationListResponseNotificationsItemSource = {
  /** 알림을 발생시킨 사용자 정보 */
  sourceUser?: NotificationListResponseNotificationsItemSourceSourceUser;
  /** 알림을 발생시킨 사용자 ID */
  sourceUserId?: number;
};
